import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';

/**
 * FileManagerSkeleton - Skeleton loader for FileManager component
 * Matches the layout of a file manager UI with header and grid of file items
 */
const FileManagerSkeleton = () => {
  const theme = useTheme();
  
  return (
    <Box className="main_content_container">
      {/* Header Section */}
      <Box 
        className="d-flex justify-content-between align-items-center p-3" 
        sx={{ 
          backgroundColor: 'primary.main',
        }}
      >
        {/* Left side - Home icon */}
        <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: 'primary.contrastText' }} />

        {/* Right side - Action icons and search */}
        <Box className="d-flex align-items-center gap-3">
          <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: 'primary.contrastText' }} />
          <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: 'primary.contrastText' }} />
          <Skeleton variant="circular" width={24} height={24} sx={{ bgcolor: 'primary.contrastText' }} />
          <Skeleton
            variant="rectangular"
            width={200}
            height={32}
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '16px',
            }}
          />
        </Box>
      </Box>

      {/* Main Content Area - Grid of file items */}
      <Box className="p-4 main_content_container">
        <Box className="row">
          {[...Array(4)].map((_, colIndex) => (
            <Box key={colIndex} className="col-lg-3 col-md-6 col-sm-12 mb-4">
              {[...Array(4)].map((_, rowIndex) => (
                <Box key={rowIndex} className="d-flex align-items-center mb-3 p-2">
                  {/* Circular icon placeholder */}
                  <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                    className="me-3"
                  />

                  {/* Text lines */}
                  <Box className="flex-grow-1">
                    <Skeleton
                      variant="text"
                      width="80%"
                      height={20}
                      className="mb-1"
                    />
                    <Skeleton variant="text" width="60%" height={16} />
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FileManagerSkeleton;
